import countriesList from './actions/countriesList';
import createCountry from './actions/createCountry';
import getCountry from './actions/getCountry';
import updateCountry from './actions/updateCountry';
import getCountries from './getters/getCountries';
import uploadCountries from './mutations/uploadCountries';

const actions = {
    countriesList,
    updateCountry,
    createCountry,
    getCountry
};

const mutations = {
    uploadCountries
};

const getters = {
    getCountries
};

export default { actions, mutations, getters };
